import { combineReducers } from 'redux';
import zoneReducers from './zoneReducers';
import { ZONE_A_ACTIONS, ZONE_B_ACTIONS } from '../constants';

export default combineReducers({
  zoneA: zoneReducers(ZONE_A_ACTIONS),
  zoneB: zoneReducers(ZONE_B_ACTIONS),
});
